import { Link } from "react-router-dom";
import ChatbotWidget from '../components/ChatbotWidget';
import { useProgramIdentity } from '../context/ProgramIdentityContext';

const apps = [
  {
    title: "Gestion du Réservoir",
    application: "reservoir",
    icon: "🏭",
    path: "/reservoir",
    image: "/tanklevel.png"
  },
  {
    title: "Barrière Automatique",
    application: "barriere",
    icon: "🚧",
    path: "/barriere",
    image: "/system_arrier.jpg"
  },
  {
    title: "Feux Tricolores",
    application: "feu_tricolore",
    icon: "🚦",
    path: "/feu-tricolore",
    image: "/feutricolores.png"
  },
  {
    title: "Système de Surveillance",
    application: "surveillance",
    icon: "📡",
    path: "/surveillance",
    image: "/sensors.png"
  }
];

export default function Home() {
  const { identity, loading, error, isApplicationActive } = useProgramIdentity();
  const identityMessage = identity?.all_applications_available
    ? 'Mode simulation : toutes les applications sont disponibles.'
    : identity?.active_application_label
      ? `Programme PLC chargé : ${identity.active_application_label}.`
      : error
        ? 'Identité du programme PLC indisponible : applications désactivées.'
        : loading
          ? 'Identification du programme PLC en cours…'
          : 'Programme PLC non reconnu : applications désactivées.';

  return (
    <div className="home-page">

      <div className="home-header">
        <h1>
          Système de Contrôle, Supervision{' '}
          <span>et Acquisition de Données</span>
        </h1>
        <p>Plateforme industrielle de supervision en temps réel</p>
        <span className="scada-badge">S C A D A</span>
      </div>

      <div className="status-bar status-bar-neutral" aria-label="Navigation vers les applications">
        {identityMessage}
      </div>

      <div className="gallery-grid">
        {apps.map((app) => {
          const enabled = isApplicationActive(app.application);
          const cardContent = (
            <>
              <img src={app.image} alt={app.title} />
              <div className="overlay">
                <div className="overlay-content">
                  <span className="overlay-icon">{app.icon}</span>
                  <h2>{app.title}</h2>
                  {!enabled && <span className="program-not-loaded">Programme non chargé</span>}
                </div>
              </div>
            </>
          );
          return (
            <Link
              key={app.path}
              to={app.path}
              className="gallery-card"
              title={enabled ? undefined : 'Ouvrir un aperçu neutre sans données temps réel'}
            >
              {cardContent}
            </Link>
          );
        })}
      </div>

      <ChatbotWidget />

    </div>
  );
}
